import { ContactRequestContactRequestTypeEnum } from '@/gql/reviews'
import { showNotification } from '@/helpers/notificationHelper'
import i18n from '@/plugins/i18n'

export const badgeColorByType: Record<ContactRequestContactRequestTypeEnum, 'purple' | 'warning' | 'success' | 'mint'> = {
  [ContactRequestContactRequestTypeEnum.ContactForm]: 'purple',
  [ContactRequestContactRequestTypeEnum.CustomQuote]: 'warning',
  [ContactRequestContactRequestTypeEnum.FileDownload]: 'success',
  [ContactRequestContactRequestTypeEnum.ReviewStarter]: 'mint',
}

// tel: only accepts digits and a leading +, so drop the separators buyers type
export const telHref = (phone: string) => `tel:${phone.replace(/[^\d+]/g, '')}`

function copyToClipboard(value: string, notificationKey: string) {
  navigator.clipboard.writeText(value)
  showNotification(i18n.global.t(notificationKey), 'success')
}

export function copyEmail(email: string) {
  copyToClipboard(email, 'Leads.action.emailCopied')
}

export function copyPhone(phone: string) {
  copyToClipboard(phone, 'Leads.action.phoneCopied')
}
